import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  CreatePlannerMutation,
  CreatePlannerMutationVariables,
  UpdatePlannerMutation,
  UpdatePlannerMutationVariables,
} from './__generated__/operations';

export const plannerFields = gql`
  fragment PlannerFields on Planner {
    firstName
    lastName
    fullName
    gravatarUrl
    email
    phone
    pastEventCount
    notes
    account {
      id
      name
    }
    title
    address {
      id
      streetAddress1
      streetAddress2
      city
      state
      zip
      country
      formattedAddress
    }
  }
`;

export const plannerSearchQuery = gql`
  query PlannerSearch(
    $organizationId: ID!
    $eventId: ID
    $query: String
    $first: Int
    $after: String
  ) {
    plannerSearch(
      organizationId: $organizationId
      eventId: $eventId
      query: $query
      first: $first
      after: $after
    ) {
      nodes {
        id
        firstName
        lastName
        fullName
        gravatarUrl
        email
        phone
        pastEventCount
        notes
        account {
          id
          name
        }
        title
        address {
          id
          streetAddress1
          streetAddress2
          city
          state
          zip
          country
          formattedAddress
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

const createMutation = gql`
  mutation CreatePlanner($input: CreatePlannerInput!) {
    createPlanner(input: $input) {
      planner {
        id
        ...PlannerFields
      }
      errors {
        message
      }
    }
  }
  ${plannerFields}
`;

const updateMutation = gql`
  mutation UpdatePlanner($input: UpdatePlannerInput!) {
    updatePlanner(input: $input) {
      planner {
        id
        ...PlannerFields
      }
      errors {
        message
      }
    }
  }
  ${plannerFields}
`;

export const useCreatePlannerMutation = ({
  ...config
}: MutationHookOptions<
  CreatePlannerMutation,
  CreatePlannerMutationVariables
>) =>
  useMutation<CreatePlannerMutation, CreatePlannerMutationVariables>(
    createMutation,
    config
  );
export const useUpdatePlannerMutation = ({ ...config }) =>
  useMutation<UpdatePlannerMutation, UpdatePlannerMutationVariables>(
    updateMutation,
    config
  );
